"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tooltip = void 0;
var _Close = _interopRequireDefault(require("@tvg/fuse-icons/lib/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledTooltip = require("./styled-tooltip");
var _excluded = ["text", "className", "closeButton", "dataTestId", "indicator", "indicatorCSSOverrides", "open", "zIndex"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  text: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  closeButton: _propTypes["default"].shape({
    show: _propTypes["default"].bool,
    props: _propTypes["default"].shape({
      callback: _propTypes["default"].func,
      className: _propTypes["default"].string,
      dataTestId: _propTypes["default"].string,
      srLabel: _propTypes["default"].string
    })
  }),
  dataTestId: _propTypes["default"].string,
  indicator: _propTypes["default"].oneOf(Object.keys(_config.arrowPosition)),
  indicatorCSSOverrides: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  zIndex: _propTypes["default"].string
};
var defaultProps = {
  className: undefined,
  closeButton: {
    show: false,
    props: {
      callback: undefined,
      className: undefined,
      dataTestId: 'fuse-tooltip-close-button-data-test-id',
      srLabel: 'Close tooltip'
    }
  },
  dataTestId: undefined,
  indicator: 'bottomLeft',
  indicatorCSSOverrides: '',
  open: false,
  zIndex: '1'
};
var Tooltip = exports.Tooltip = forwardRef(function (_ref, ref) {
  var text = _ref.text,
    className = _ref.className,
    closeButton = _ref.closeButton,
    dataTestId = _ref.dataTestId,
    indicator = _ref.indicator,
    indicatorCSSOverrides = _ref.indicatorCSSOverrides,
    open = _ref.open,
    zIndex = _ref.zIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledTooltip.StyledTooltip, _extends({
    "aria-hidden": open ? undefined : true,
    className: className,
    "data-testid": dataTestId || 'fuse-tooltip-test-id',
    indicator: indicator,
    open: open,
    ref: ref,
    zIndex: zIndex
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledTooltip.StyledTooltipContent, {
    indicatorCSSOverrides: indicatorCSSOverrides,
    indicator: indicator,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(_styledTooltip.StyledTooltipText, null, text), closeButton.show && /*#__PURE__*/_react["default"].createElement(_styledTooltip.StyledTooltipButton, _extends({}, closeButton.props, {
    color: "var(--color-global-white)",
    icon: /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    height: "".concat(Math.round(16 / 16 * 1.6 * 10) / 10, "rem"),
    width: "".concat(Math.round(16 / 16 * 1.6 * 10) / 10, "rem")
  }))));
});
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
var _default = exports["default"] = Tooltip;